import React from "react";
import { MultiSelect } from "components/common";
import { Input } from "components/bootstrap";
import { optionableLabel } from "components/configurationforms/FieldHelpers";
const ListField = ({ autoFocus = false, field, onChange, title, typeName, value = void 0 }) => {
  var _a;
  const handleChange = (nextValue) => {
    const values = nextValue === "" ? [] : nextValue.split(",");
    onChange(title, values);
  };
  const isRequired = !field.is_optional;
  const allowCreate = field.attributes.includes("allow_create");
  const options = ((_a = field.additional_info) == null ? void 0 : _a.values) || {};
  const formattedOptions = Object.entries(options).map(([label, optionValue]) => ({
    value: optionValue,
    label
  }));
  const selectValue = Array.isArray(value) ? value.join(",") : value;
  return /* @__PURE__ */ React.createElement(Input, { id: `${typeName}-${title}`, label: optionableLabel(field), help: field.description }, /* @__PURE__ */ React.createElement(
    MultiSelect,
    {
      inputId: `${typeName}-${title}`,
      name: `configuration[${title}]`,
      required: isRequired,
      autoFocus,
      className: "list-field-select",
      options: formattedOptions,
      value: selectValue,
      placeholder: `${allowCreate ? "Add" : "Select"} ${field.human_name}`,
      onChange: handleChange,
      allowCreate
    }
  ));
};
export default ListField;
